module.exports = __webpack_public_path__ + "static/play-store-download-fc0357c9256a7734d818b07ab5dd066a.png";